import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import {SessionSiteSelectors} from '~selectors/SessionInfoSelectors';
import {getAppStore} from '~src/app/AppStore';

import { Messages } from '../../codegen/Localize';
import { PublishedConnectionContentType } from '../../spacesPlatform/models/ContentTypes';
import { TagErrorCode } from '../../ts/helpers/ErrorCodes';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';

// TODO - achristian - 2020-01-23 - TFSID:1059556 - Remove this mock when hooked up to TAG services.
export enum PublishedConnectionErrorCode {
  PublishedConnectionNameAlreadyExistsInDestinationProject = -1,
  BadRequest = -2,
  PublishedConnectionNotFound = -3,
  InvalidRequest = -4,
  PublishedConnectionNameAlreadyExists = -5,
  InternalError = -6,
  ServiceUnavailable = -7,
  ServiceRequestFailed = -8
}

function errorDetailsFor(publishedConnectionErrorItem: IErrorItem<IPublishedConnectionInfo>): IErrorDetail {
  return {
    itemName: publishedConnectionErrorItem.item.name,
    itemUrl:
        publishedConnectionErrorItem.error.code === PublishedConnectionErrorCode.PublishedConnectionNotFound
        ? null
        : ContentUrlForItem(publishedConnectionErrorItem.item, PublishedConnectionContentType),
    errorMessage: this.errorMessageFor(publishedConnectionErrorItem)
  };
}

function errorMessageFor(errorItem: IErrorItem<IPublishedConnectionInfo>) {
  const publishedConnection = errorItem.item;
  switch (errorItem.error.code) {
    case PublishedConnectionErrorCode.PublishedConnectionNotFound:
      return Messages.errorPublishedConnectionNotFound({PUBLISHED_CONNECTION_NAME: publishedConnection.name});
    case PublishedConnectionErrorCode.PublishedConnectionNameAlreadyExistsInDestinationProject:
      return Messages.errorPublishedConnectionNameAlreadyExistsInDestinationProject();
    case TagErrorCode.TooManyTags:
      return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
    default:
      return Messages.errorUnknown();
  }
}

export const PublishedConnectionErrors = {
  errorDetailsFor,
  errorMessageFor
};
